import React, { useEffect, useState } from "react";
import * as style from "./ValueStreamsPanelContent.module.scss";
import Typography from "../../Components/Common/CprimeText";
import { Divider, Dropdown, TextArea } from "cprime-foundational-components";

interface AddApplicationPanelContentProps {
  nameValueStream: any;
  descriptionValueStream: any;
  data: any;
  descriptionAppHandler: Function;
  descriptionApp: string;
  setAppId: Function;
}

const AddApplicationPanelContent: React.FC<AddApplicationPanelContentProps> = ({
  data,
  descriptionAppHandler,
  descriptionApp,
  setAppId,
}) => {
  const scssClass = style as any;
  const [applicationOptions, setApplicationOptions] = useState([]);
  const [applicationSelectedOption, setApplicationSelectedOption] = useState(
    [],
  );
  const [description, setDescription] = useState({} as any);

  useEffect(() => {
    const options = data?.map((item: any) => ({
      id: item?.id,
      label: item?.app_cmdb_name,
      description: item?.description,
    }));
    setApplicationOptions(options);
  }, [data]);

  return (
    <div className={scssClass.panelContent}>
      <Divider
        variant={"fullWidth"}
        sx={{
          marginBottom: "15px",
          width: "100%",
          marginLeft: "0px !important",
          backgroundColor: "#f8f8f9 !important",
        }}
      />
      <Typography className={scssClass.textDescription}>
        Application Details
      </Typography>
      <div className={scssClass.fieldsContent}>
        <Typography style={{ fontSize: "12px" }}>Application</Typography>
        <Dropdown
          placeholder="Select"
          optionsTextLimit={200}
          style={{ width: "100%" }}
          fullWidth
          multiple={false}
          options={applicationOptions}
          selectedOptions={applicationSelectedOption}
          onChange={(options) => {
            setAppId(options[0]?.id);
            setApplicationSelectedOption(options as any);
            setDescription(options[0] as any);
          }}
          error={false}
          errorMessage={""}
        />
        <TextArea
          fullWidth
          label={<>Description</>}
          aria-label="minimum height"
          minRows={3}
          placeholder=""
          style={{ width: "99.5%" }}
          value={
            description?.description == null ? "" : description?.description
          }
          onChange={(e) => {
            descriptionAppHandler(e?.target?.value);
          }}
          maxLength={500}
          readOnly
        />
      </div>
    </div>
  );
};
export default AddApplicationPanelContent;
